import { Directive, effect, ElementRef, inject, input, model, OnInit, Renderer2, signal } from '@angular/core';

import { WSize } from '../model';

@Directive({
    selector: '[collapsible]',
    standalone: true,
    host: {
        '[class.collapsible]': 'true'
    }
})
export class CollapsibleDirective implements OnInit {

    $triggerSelector = input.required<string>({ alias: 'collapseTrigger' });
    $collapseIconSize = input<string>(null, { alias: 'collapseIconSize' });
    $isCollapsed = model(false, { alias: 'collapsed' });

    private readonly renderer = inject(Renderer2);
    private readonly el = inject(ElementRef);

    private get nativeEl() {
        return this.el.nativeElement;
    }

    constructor() {

        effect(() => {
            const triggerSelector = this.$triggerSelector();
            const trigger = this.nativeEl.querySelector(triggerSelector);

            if (!trigger) return;

            this.renderer.setProperty(trigger, 'title', 'Click to expand/collapse');
            this.renderer.setStyle(trigger, 'cursor', 'pointer');
            this.renderer.setStyle(trigger, 'user-select', 'none');
            this.renderer.listen(trigger, 'click', () => this.toggle());


        });

        effect(() => {
            const isCollapsed = this.$isCollapsed();

            isCollapsed
                ? this.renderer.addClass(this.nativeEl, 'collapsed')
                : this.renderer.removeClass(this.nativeEl, 'collapsed');

            const icon = this.nativeEl.querySelector('.collapsible-icon');

            if (!icon) return;

            if (isCollapsed) {
                this.renderer.removeClass(icon, 'fa-chevron-down');
                this.renderer.addClass(icon, 'fa-chevron-right');
            } else {
                this.renderer.removeClass(icon, 'fa-chevron-right');
                this.renderer.addClass(icon, 'fa-chevron-down');
            }
        });

        effect(() => {

            const icon = this.nativeEl.querySelector('.collapsible-icon');

            if (!icon) return;

            const size = this.$collapseIconSize();

            const sizeMap: Record<WSize, string> = {
                xs: 'var(--font-size-12px)',
                small: 'var(--font-size-12px)',
                medium: 'var(--font-size-14px)',
                large: 'var(--font-size-14px)',
            }

            if (size) {
                this.renderer.setStyle(icon, 'font-size', sizeMap[size]);
            }

        });

    }

    ngOnInit(): void {

        this.renderer.setStyle(this.nativeEl, 'position', 'relative');

        const icon = this.renderer.createElement('i');

        // set classes
        const classes = [
            'collapsible-icon',
            'fa-regular',
            this.$isCollapsed() ? 'fa-chevron-right' : 'fa-chevron-down'
        ];
        classes.forEach((cls) => this.renderer.addClass(icon, cls));

        // set styles
        const styles = {
            position: 'absolute',
            left: '0',
            cursor: 'pointer',
            color: 'var(--component-color-control-header-arrow-icon, #6B7280)',
            'font-size': 'var(--font-size-12px)',
        }
        Object.keys(styles).forEach((key) => this.renderer.setStyle(icon, key, styles[key]));

        // set listeners
        this.renderer.listen(icon, 'click', () => this.toggle());

        // append to host
        this.renderer.appendChild(this.nativeEl, icon);

    }

    toggle(): void {
        this.$isCollapsed.update((isCollapsed) => !isCollapsed);
    }



}